import { Box, styled } from '@mui/material';
import { spaceCadet, ultraMarine } from '../../../../../../../../../../../utils/colors';

const StyledBox = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  gap: 4,
  '& > .MuiTypography-body1': {
    color: spaceCadet[500],
    fontSize: 14,
    lineHeight: '16px',
    width: 'max-content',
  },
  '& > .MuiButtonBase-root': {
    textTransform: 'none',
    padding: 0,
    lineHeight: '16px',
    backgroundColor: 'transparent',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  '& > .MuiTypography-body2': {
    color: ultraMarine[500],
    fontSize: 14,
    lineHeight: '16px',
  },
});

export default StyledBox;
